document.addEventListener('DOMContentLoaded', () => {
  const progressPath = document.querySelector('.button__back-to-top .progress-circle path');
  if (!progressPath) return;

  const pathLength = progressPath.getTotalLength();
  progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
  progressPath.style.strokeDashoffset = String(pathLength);
  progressPath.style.transition = 'stroke-dashoffset 10ms linear';

  let lastOffset = pathLength;
  let ticking = false;
  let cachedHeight = 0;

  function measureHeight() {
    cachedHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (cachedHeight <= 0) cachedHeight = 1;
  }

  function updateProgress() {
    const scroll = window.scrollY || window.pageYOffset;
    const offset = pathLength - (scroll * pathLength) / cachedHeight;
    if (offset !== lastOffset) {
      progressPath.style.strokeDashoffset = String(offset);
      lastOffset = offset;
    }
    ticking = false;
  }

  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateProgress);
  }

  function onResize() {
    measureHeight();
    scheduleUpdate();
  }

  measureHeight();
  updateProgress();

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });
});
